import React, { useState, useEffect, useRef } from "react"
import { scroller } from "react-scroll"
import cx from "classnames"
import Sticky from "react-sticky-el"
import LazyLoad from "react-lazy-load"
// import Sort from "./Sort"
import Filter from "./Filter"
import ProductTile from "./ProductTile"
import ProductsPerPage from "./ProductsPerPage"
import shareIcon from "@/public/icons/share.svg"
import filterIcon from "@/public/icons/filter.svg"
import printIcon from "@/public/icons/print.svg"
import backToTop from "@/public/icons/back-top-arrow.svg"
import columnOffIcon from "@/public/icons/column-off.svg"
import columnOnIcon from "@/public/icons/column-on.svg"
import gridOffIcon from "@/public/icons/grid-off.svg"
import gridOnIcon from "@/public/icons/grid-on.svg"
//import { getSwatchCount } from "@Globals/js/helper";
import { isMobile, withOrientationChange, isTablet } from "react-device-detect"
import SocialShare from "@/components/SocialShare/v1/SocialShare"
import Button from "@/components/core/Button/Button"
import searchIcon from "@/public/icons/search.svg"
import { addDataLayer } from "../analytics"
import closeIcon from "@/public/icons/close.svg"
import InspirationDetail from "@/components/InspirationDetail/v1/InspirationDetail"
import { getStock } from "@/utils/cart"
import useWindowResize from "@/hooks/useWindowResize"
import { getConfig } from "@/constants/config"

const InspirationLandingList = props => {
  const [width] = useWindowResize()
  const isGainsboroBg = props?.bgColor === "bg-gainsboro" ? true : false
  const { isLandscape, selectedFilterCount, facets, facetLabels } = props
  const [showFilter, setShowFilter] = useState(props?.enableFilter)
  const [navSticky, setNavSticky] = useState(false)
  const [isModalShow, setIsModalShow] = useState(false)
  const [currentScrollPosition, setCurrentScrollPosition] = useState(0)
  const [selectedInspiration, setSelectedInspiration] = useState(null)
  // const [showInspirationModal, setShowInspirationModal] = useState(false);
  // const [selectedInspiration, setSelectedInspiration] = useState(null);
  const [filterValue, setFilterValue] = useState("")
  const [rowCols, setRowCols] = useState(width < 1024 ? 1 : 3)
  const [scrollPosition, setScrollPosition] = useState(0)
  const [isDataAvailable, setIsDataAvailable] = useState(false)
  const resultField = useRef(null)
  const filterClass = cx({
    "inspiration-list__filter": true,
    "inspiration-list__filter--hide":
      width < 1024 && isMobile ? (isTablet ? !showFilter : false) : !showFilter,
    "inspiration-list__filter--modal": showFilter,
  })
  const filterButtonClass = cx({
    "inspiration-list__filter-toggle-text": true,
    "inspiration-list__filter-toggle-text--show": !showFilter,
  })
  const tileClass = cx({
    "inspiration-list__tile-col": true,
    "inspiration-list__tile-col--full-width": !showFilter,
  })
  const [showSocialLink, setShowSocialLink] = useState(false)
  // let width = window.innerWidth
  const searchVal = useRef(0)
  const [brandName, setBrandName] = useState("")
  useEffect(() => {
    document
      ?.querySelector("title")
      .setAttribute("aria-label", props?.staticTexts?.pageTitleAria)
      setShowFilter(!isMobile)
  }, [])

  //BackToTop button focus to breadcrumb for ADA
  const handleKeyUp = event => {
    if (event.keyCode === 13) {
      setTimeout(() => {
        const inactiveBread = document.querySelector(
          ".cmp-breadcrumb__item-link"
        )
        if (inactiveBread) {
          inactiveBread.focus()
        }
      }, 100)
    }
  }
  useEffect(() => {
    document.addEventListener("keyup", handleKeyUp)
    return () => {
      document.removeEventListener("keyup", handleKeyUp)
    }
  }, [])

  useEffect(() => {
    isTablet
      ? window.outerWidth >= 1024
        ? setRowCols(3)
        : setRowCols(2)
      : isMobile && width < 1024
      ? isLandscape
        ? setRowCols(2)
        : setRowCols(2)
      : setRowCols(3)
  }, [isLandscape])
  useEffect(() => {
    if (props?.data?.length) {
      setIsDataAvailable(false)
    } else {
      setIsDataAvailable(true)
    }
  }, [props?.data])
  const getAvailableStock = async sku => {
    let stock = 0
    try {
      stock = await getStock(sku)
    } catch (err) {
      console.error(
        "Error | getStock | getAvailablesStock | ProductDetails | ",
        err
      )
    }
    return stock
  }

  useEffect(() => {
    getConfig().then(async CONFIG => {
      setBrandName(CONFIG?.general?.siteName.toLowerCase() ?? "")
    })
  }, [])
  const getVarientProductInfo = obj => {
    const inStock = getAvailableStock(obj.masterVariant.sku)
    const productInfo = {
      description: obj.description["en-US"],
      frequency: "n/a",
      globalPromotionPrice: parseFloat(
        (obj.masterVariant.prices[0]?.discounted?.value?.centAmount ||
          obj.masterVariant.prices[0]?.value?.centAmount) / 100
      ).toFixed(2),
      isRecommended: "n/a",
      isSendNow: "n/a",
      isSubscription: "n/a",
      priceState: "regular price",
      productBasePrice: parseFloat(
        obj.masterVariant.prices[0]?.value?.centAmount / 100
      ).toFixed(2),
      productCategory:
        obj.masterVariant.attributes
          .filter(items => items.name === "ProductLocalCategory")
          .map(item => {
            return item.value
          })[0] || "n/a",
      productColor:
        obj.masterVariant.attributes
          .filter(items => items.name === "SKUColorFinishName")
          .map(item => {
            return item.value["en-US"]
          })[0] || "n/a",
      productCoupondiscount: 0,
      productCouponCode: "n/a",
      productID: obj.masterVariant.sku,
      productName: obj.name["en-US"],
      productPartnerBuyNow: false,
      productRoom: obj.metaTitle["en-US"].split("|")[0].trim(),
      productSalePrice: parseFloat(
        (obj.masterVariant.prices[0]?.discounted?.value?.centAmount ||
          obj.masterVariant.prices[0]?.value?.centAmount) / 100
      ).toFixed(2),
      productSaleable: true,
      productStatus: inStock > 0 ? "in stock" : "out of stock",
      productSuperSku: false,
      productTileName: obj.name["en-US"],
      quantity: 1,
      defaultImageName: obj.masterVariant?.images[0]?.url || "n/a",
      ratings: "n/a",
      numberOfReviews: "n/a",
      pdpType: "regular finished Goods",
      productFindingMethod: "n/a",
      productCollectionsName:
        obj.masterVariant.attributes
          .filter(items => items.name === "ProductBrandName")
          .map(item => {
            return item.value
          })[0] || "n/a",
      productBrand: brandName,
      globalOffer: "n/a",
      globalDiscount:
        obj.masterVariant.prices[0]?.discounted?.value?.centAmount ?? 0,
      itemType: "product",
    }

    return JSON.stringify(productInfo)
  }

  //calculate promo position
  // const col =
  //   window.outerWidth < 1024
  //     ? {
  //       "one-column": "col-12",
  //       "two-column": "col-12",
  //       "three-column": "col-12",
  //     }
  //     : {
  //       "one-column": "col",
  //       "two-column": "col-8",
  //       "three-column": "col-12",
  //     };
  //const colVal = { "one-column": 1, "two-column": 2, "three-column": 3 };
  // const row = isMobile
  //   ? props?.promoPlacementMobile
  //   : props?.promoPlacementDesktop;
  // const position = (isMobile && window.outerWidth < 1024)
  //   ? rowCols === 1
  //     ? row - 1
  //     : row * rowCols - 2
  //   : row * rowCols - colVal[props?.promoLayout];

  const plpDisplayName = props?.urlTitle
    ? props?.urlTitle
    : props?.plpDisplayName

  const executeScroll = () => {
    scroller.scrollTo("products-tab", {
      duration: 1500,
      delay: 0,
      smooth: "easeInOutQuart",
    })
  }

  const loadMoreClickHandler = () => {
    props?.onLoadMore()
    addDataLayer({
      title: props?.staticTexts.loadMore.toLowerCase(),
      cart_ID: props?.cart?.id,
    })
  }
  const onInspirationSelect = data => {
    setSelectedInspiration(data)
    setIsModalShow(true)
    document.body.classList.add("body-scroll-disable")
  }
  const closeModal = data => {
    document.body.classList.remove("body-scroll-disable")
    setIsModalShow(false)
  }

  const backToTopClickHandler = () => {
    resultField?.current?.focus();
    window.scrollTo({ top: 200, behavior: "smooth" })
    addDataLayer({
      title: props?.staticTexts.backToTop.toLowerCase(),
      cart_ID: props?.cart?.id,
    })
  }

  const handleChange = event => {
    if (event.target.value.length === 0) {
      setFilterValue("")
      props?.onFilter(null, false, "", addDataLayer)
    }
    if (event.target.value.length > 2 || event.key === "Enter") {
      setFilterValue(event.target.value)
      props?.onFilter(null, false, event.target.value, addDataLayer)
    }
  }
  const handleSearch = event => {
    if (filterValue !== event.target.value && event.target.value.length < 3) {
      props?.onFilter(null, false, event.target.value)
    }
    setFilterValue(event.target.value)
    searchVal.current.placeholder = "Search Design Inspiration"
  }

  const removeSearch = () => {
    setFilterValue("")
    props?.onFilter(null, false, "")
    searchVal.current.value = ""
  }
  const onbeforeprint = () => {
    forceVisible()
  }

  const filterToogleHandler = () => {
    addDataLayer({
      title: showFilter ? "hide filters" : "show filters",
      cart_ID: props?.cart?.id,
      filterProps: {
        isFilter: true,
      },
    })
    setShowFilter(!showFilter)
  }

  return (
    <div className="inspiration-landing">
      <div className="inspiration-list">
        {/* hero-banner */}
        {!props?.isCurated && (
          <div
            className={cx(
              "container kf-react-container inspiration-list__header",
              isGainsboroBg && "inspiration-list--gainsboro"
            )}
          >
            <div className="row">
              <div className="inspiration-list__title-info col-lg-12 col-xs-12">
                <h1
                  tabIndex="0"
                  aria-label={plpDisplayName}
                  className="inspiration-list__title"
                >
                  {plpDisplayName}
                </h1>
              </div>
            </div>
            <div className="row d-block d-lg-none">
              <div className="col">
                <div className="inspiration-list__grid-control">
                  <div
                    aria-label={props?.staticTexts.totalResults}
                    className="inspiration-list__total"
                    tabIndex="0"
                  ></div>
                  <div className="d-block d-sm-none">
                    <img
                      onClick={() => setRowCols(1)}
                      className="inspiration-list__grid-control-icon"
                      src={rowCols > 1 ? columnOffIcon : columnOnIcon}
                      alt="Column View"
                    />
                    <img
                      onClick={() => setRowCols(2)}
                      className="inspiration-list__grid-control-icon"
                      src={rowCols > 1 ? gridOnIcon : gridOffIcon}
                      alt="Grid View"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {props?.isCurated && (
          <div className="container kf-react-container inspiration-list__header inspiration-list__curated">
            <div className="row">
              <div className="col-lg-8 col-xs-12">
                <h2
                  aria-label={props?.staticTexts.totalResults}
                  className="inspiration-list__total d-none d-lg-block"
                  tabIndex="0"
                >
                  {props?.totalResults} {props?.staticTexts.results}
                </h2>
              </div>
            </div>
            <div className="row d-block d-lg-none">
              <div className="col">
                <div className="inspiration-list__grid-control">
                  <h2
                    aria-label={props?.staticTexts.totalResults}
                    className="inspiration-list__total"
                  >
                    {props?.totalResults} {props?.staticTexts.results}
                  </h2>
                  <div className="d-block d-sm-none">
                    <img
                      onClick={() => setRowCols(1)}
                      className="inspiration-list__grid-control-icon"
                      src={rowCols > 1 ? columnOffIcon : columnOnIcon}
                      alt="Column View"
                    />
                    <img
                      onClick={() => setRowCols(2)}
                      className="inspiration-list__grid-control-icon"
                      src={rowCols > 1 ? gridOnIcon : gridOffIcon}
                      alt="Grid View"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* controls */}
        <Sticky
          onFixedToggle={() => setNavSticky(!navSticky)}
          className="inspiration-list__sticky-nav-wrap"
          stickyStyle={{ zIndex: 9 }}
        >
          <div
            className={`container-fluid inspiration-list__sticky-nav ${
              navSticky && "inspiration-list__sticky-nav--shadow"
            }`}
          >
            <div className="row">
              <div className="container kf-react-container">
                <div className="row">
                  <div className="col">
                    <div className="inspiration-list__total" aria-live="polite" role="status">
                      {!props?.loading && props?.data.length > 0 && (
                        <span className="textItem" ref={resultField} tabIndex="0">
                          {props?.totalResults} {props?.staticTexts.items}
                        </span>
                      )}
                      <div className="inputWithIcon">
                        <input
                          type="text"
                          id="search"
                          name="search"
                          className="form__input search"
                          onKeyUp={handleChange}
                          onBlur={handleSearch}
                          placeholder="Search Design Inspiration"
                          onFocus={e => (e.target.placeholder = "")}
                          ref={searchVal}
                        />
                        <img
                          className="search-icon"
                          src={searchIcon}
                          alt="search-icon"
                        />
                      </div>
                    </div>
                    {props?.data && props?.data.length > 0 && (
                      <div className="inspiration-list__controls">
                        {facets && (
                          <button
                            tabIndex="-1"
                            className="inspiration-list__filter-toggle"
                            onClick={filterToogleHandler}
                          >
                            <img
                              src={filterIcon?.src}
                              className="inspiration-list__filter-toggle-icon"
                              alt="Toggle Filter"
                            />
                            {isMobile && !isLandscape && !isTablet ? (
                              <span>
                                {props?.staticTexts.showFilter}{" "}
                                {selectedFilterCount > 0 &&
                                  ` (${selectedFilterCount})`}
                              </span>
                            ) : isMobile &&
                              isLandscape &&
                              !isTablet &&
                              width < 1024 ? (
                              <span>
                                {props?.staticTexts.showFilter}{" "}
                                {selectedFilterCount > 0 &&
                                  ` (${selectedFilterCount})`}
                              </span>
                            ) : isMobile &&
                              !isLandscape &&
                              isTablet &&
                              width < 1024 ? (
                              <span>
                                {props?.staticTexts.showFilter}{" "}
                                {selectedFilterCount > 0 &&
                                  ` (${selectedFilterCount})`}
                              </span>
                            ) : (
                              <ul
                                tabIndex="0"
                                aria-labelledby={
                                  showFilter
                                    ? "Hide the filters"
                                    : "Show the filters"
                                }
                                className={filterButtonClass}
                              >
                                <li className={showFilter ? "show" : "hide"}>
                                  {props?.staticTexts.hideFilter}
                                </li>
                                <li className={!showFilter ? "show" : "hide"}>
                                  {props?.staticTexts.showFilter}
                                </li>
                              </ul>
                            )}
                          </button>
                        )}
                        <section className="sorting-section">
                          {/* 
                      // The code will be uncommented once the data dependency from LW is resolved
                      <Sort
                        tabIndex="0"
                        data={props?.sorts}
                        texts={props?.staticTexts}
                        onChange={props?.onSort}
                      /> */}
                        </section>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Sticky>
        {props?.loading &&
        (props?.data === null || props?.data.length === 0) ? (
          <div className="container kf-react-container inspiration-list__tiles">
            <div className="row">
              <div className="col">
                <div className="inspiration-list__not-found">
                  {props?.i18n.loading}
                </div>
                <div className="inspiration-list__try-other">
                  {props?.i18n.pleaseWait}
                </div>
              </div>
            </div>
          </div>
        ) : props?.data && props?.data.length === 0 && isDataAvailable ? (
          <div className="container kf-react-container inspiration-list__tiles">
            <div className="row">
              {filterValue !== "" ? (
                <div className="col">
                  <div className="inspiration-list__not-found">
                    {props?.i18n.matchNotFound}
                  </div>
                  <div className="inspiration-list__try-other">
                    {props?.i18n.otherCombination}
                  </div>
                </div>
              ) : (
                <div className="col">
                  <div className="inspiration-list__not-found">
                    {props?.i18n.noDataFound}
                  </div>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="container kf-react-container inspiration-list__tiles">
            <div className="row">
              <div className="col">
                <div className="inspiration-landing-main">
                  {isModalShow && (
                    <div className="inspiration-modal-display-block">
                      <div
                        className="inspiration-modal__closeImg"
                        onClick={() => closeModal()}
                      >
                        <img src={closeIcon.src} />
                      </div>
                      <InspirationDetail
                        selectedInspiration={selectedInspiration}
                        displayShare={props?.displayShare ? true : false}
                        displayPrint={props?.displayPrint ? true : false}
                        isModalShow={isModalShow}
                        isOverlay={true}
                        cart={props?.cart}
                        getVarientProductInfo={getVarientProductInfo}
                      />
                    </div>
                  )}
                  <div className={filterClass}>
                    <div
                      className={`inspiration-list__filter--sticky ${
                        props?.isCurated
                          ? " inspiration-list__filter-curated"
                          : ""
                      }`}
                    >
                      {props?.data && props?.data.length > 0 && facets && (
                        <Filter
                          tabIndex="0"
                          texts={props?.staticTexts}
                          {...props}
                          facetLabels={facetLabels}
                          close={setShowFilter}
                          displayShare={
                            props?.displayShare === "true" ? true : false
                          }
                          displayPrint={
                            props?.displayPrint === "true" ? true : false
                          }
                          selectedFilterCount={selectedFilterCount}
                          handleScroll={executeScroll}
                          showFilter={showFilter}
                          addToUrl={true}
                          removeSearch={removeSearch}
                          cartId={props?.cart?.id}
                          getVarientProductInfo={getVarientProductInfo}
                        />
                      )}
                    </div>
                  </div>
                  <div className={tileClass}>
                    <div className={`row row-cols-${rowCols}`}>
                      {props?.data &&
                        props?.data.length > 0 &&
                        props?.data?.map((product, i) => (
                          <React.Fragment key={i}>
                            <div className="col inspiration-list__tile">
                              <LazyLoad>
                                <ProductTile
                                  tabIndex="0"
                                  loading={props?.loading}
                                  data={product}
                                  staticTexts={props?.staticTexts}
                                  displayShare={
                                    props?.displayShare ? true : false
                                  }
                                  displayPrint={
                                    props?.displayPrint ? true : false
                                  }
                                  favorites={props?.favorites}
                                  cart={props?.cart}
                                  setIsModalShow={setIsModalShow}
                                  isModalShow={isModalShow}
                                  onInspirationSelect={onInspirationSelect}
                                />
                              </LazyLoad>
                            </div>
                          </React.Fragment>
                        ))}
                    </div>
                    <div className="row">
                      {props?.totalResults > props?.curRows &&
                        props?.totalResults > props?.data?.length && (
                          <button
                            onClick={loadMoreClickHandler}
                            className="kf-react-button button small load-more inspiration-list__load-more"
                          >
                            {props?.staticTexts?.loadMore}
                          </button>
                        )}
                    </div>
                    <div className="row">
                      <div
                        className={
                          props?.totalResults > 30
                            ? "inspiration-list__back-to-top"
                            : "inspiration-list__back-to-top inspiration_back-to-top"
                        }
                      >
                        {isMobile && (
                          <div className="inspiration-list__print-and-share">
                            {props?.displayPrint === "true" && (
                              <span
                                role="button"
                                onClick={() => window.print()}
                              >
                                {props?.staticTexts.print}
                                <img
                                  src={printIcon}
                                  alt={props?.staticTexts.print}
                                />
                              </span>
                            )}
                            {props?.displayShare === "true" && (
                              <span
                                role="button"
                                onClick={() =>
                                  setShowSocialLink(!showSocialLink)
                                }
                              >
                                {props?.staticTexts.share}
                                <img
                                  src={shareIcon}
                                  alt={props?.staticTexts.share}
                                />
                              </span>
                            )}
                            <SocialShare
                              showModal={showSocialLink}
                              id="kf-product-list"
                              onClose={() => setShowSocialLink(false)}
                            />
                          </div>
                        )}
                        {!isMobile && props?.totalResults > 30 && (
                          <ProductsPerPage
                            pos="bottom"
                            curRows={props?.curRows}
                            data={props?.productsPerPage}
                            totalResults={props?.totalResults}
                            texts={props?.staticTexts}
                            onChange={props?.onRows}
                            addDataLayer={addDataLayer}
                            cartId={props?.cart?.id}
                          />
                        )}
                        <button
                          className="inspiration-list__go-back"
                          aria-label={props?.staticTexts?.backToResult}
                          onClick={backToTopClickHandler}
                        >
                          {props?.staticTexts.backToTop}{" "}
                          <img src={backToTop.src} alt={""} />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default InspirationLandingList
